import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initSupabase } from '@/lib/supabase'
import { AuthProvider } from '@/auth/auth-provider'
import { ThemeProvider } from '@/components/theme-provider'
import { TooltipProvider } from '@/components/ui/tooltip'
import { App } from '@/App'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root')!)

// The Supabase client needs the tenant's anon key from /config.json, so the app
// can't render until that resolves. Failing here rather than inside a component
// keeps "the backend is unreachable" from looking like a broken page.
initSupabase()
  .then(() => {
    root.render(
      <React.StrictMode>
        <ThemeProvider>
          <TooltipProvider delayDuration={300}>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrowserRouter>
          </TooltipProvider>
        </ThemeProvider>
      </React.StrictMode>,
    )
  })
  .catch((err: unknown) => {
    const message = err instanceof Error ? err.message : String(err)
    root.render(
      // Inline styles, not Tailwind classes: this renders when startup failed,
      // and the stylesheet may be exactly what didn't load.
      <div style={{ font: '15px/1.6 Outfit, system-ui, sans-serif', maxWidth: 560, margin: '5rem auto', padding: '0 1.5rem' }}>
        <h1 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#182239' }}>
          Team Accelerator couldn&apos;t start
        </h1>
        <p style={{ color: '#5b666d' }}>{message}</p>
      </div>,
    )
  })
